import { InverseHeader } from '@jouzen/ecom-components/layout';
import { RadialGradientBG } from '@jouzen/ecom-components/v3/GradientBG';

import PageLayout from '@/app/components/PageLayout';
import RichText from '@/app/components/RichText';
import { LEGAL_FOOTNOTES_ID } from '@/app/consts/ids';

import MembershipBenefits from './_components/MembershipBenefits/MembershipBenefits';
import MembershipBetterSleep from './_components/MembershipBetterSleep/MembershipBetterSleep';
import MembershipFAQ from './_components/MembershipFAQ/MembershipFAQ';
import MembershipFeatures from './_components/MembershipFeatures/MembershipFeatures';
import MembershipHero from './_components/MembershipHero/MembershipHero';
import MembershipInfoFeatureGrid from './_components/MembershipInfoFeatureGrid/MembershipInfoFeatureGrid';
import MembershipYourHealth from './_components/MembershipYourHealth/MembershipYourHealth';
import { membershipGradients } from './_data/membershipGradients';

interface ContentControlProps {
  readonly localePartialUrl: string;
}

const ContentControl = ({ localePartialUrl }: ContentControlProps) => {
  return (
    <PageLayout
      pageName="membership"
      containerProps={{
        className: 'bg-sandstone-200 text-sandstone-500',
        name: 'membership',
        padding: 'none',
      }}
      footerProps={{
        wrapperClassName: 'bg-gray-600',
      }}
      footnotesProps={{
        id: LEGAL_FOOTNOTES_ID,
        footnotes: [
          {
            marker: '*',
            content: (
              <RichText
                messageKey="footnote_heart_rate_hrv_accuracy_source"
                tValues={{
                  link: (chunks: React.ReactNode) => (
                    <a
                      href={`https://ouraring.com/blog${localePartialUrl}how-accurate-is-oura/`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-current underline"
                    >
                      {chunks}
                    </a>
                  ),
                }}
              />
            ),
          },
          {
            marker: '**',
            content: (
              <RichText
                messageKey="footnote_smart_sensing_source"
                tValues={{
                  link: (chunks: React.ReactNode) => (
                    <a
                      href={`https://ouraring.com/blog${localePartialUrl}smart-sensing/`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-current underline"
                    >
                      {chunks}
                    </a>
                  ),
                }}
              />
            ),
          },
          {
            marker: '***',
            content: <RichText messageKey="footnote_personal_baseline" />,
          },
          {
            marker: '****',
            content: (
              <RichText messageKey="footnotes_membership_pricing_updated" />
            ),
          },
        ],
      }}
    >
      <RadialGradientBG gradients={membershipGradients}>
        <div data-cy="membership-page">
          <MembershipHero />
          <MembershipFeatures />
          <MembershipInfoFeatureGrid />
          <MembershipYourHealth />
          <MembershipBenefits />
          <InverseHeader enter>
            <MembershipFAQ />
            <MembershipBetterSleep />
          </InverseHeader>
        </div>
      </RadialGradientBG>
    </PageLayout>
  );
};

export default ContentControl;
